import type { AlertV2Severity } from "src/components/AlertV2/AlertV2.tsx";
import type { ExactTheme } from "src/lib/emotion/theme.ts";
import { css } from "@emotion/react";

export const icon =
  ({ severity }: { severity: AlertV2Severity }) =>
  (theme: ExactTheme) => css`
    display: flex;
    justify-content: center;
    align-items: center;
    width: 32px;
    height: 32px;
    border-radius: 50%;
    font-size: 16px;
    background-color: ${{
      info: theme.colorsV2.blue[50],
      success: theme.colorsV2.green[50],
      error: theme.colorsV2.red[50],
      warning: theme.colorsV2.orange[50],
    }[severity]};
    color: ${{
      info: theme.colorsV2.blue[500],
      success: theme.colorsV2.green[500],
      error: theme.colorsV2.red[500],
      warning: theme.colorsV2.orange[500],
    }[severity]};
  `;
